export const authClientName = "ai-in-service";
